export enum SelectionInput {
  RadioButton = 0,
  CheckBox = 1,
  DropDownList = 2,
  PlusMinusSelector = 3,
}
